import { useQuery } from '@tanstack/react-query'

import {
  getAllBookingProducts,
  getAllBookingProductsAvailability,
  getBookingById,
} from '@flecto/api/saas'
import { type CoreBookingProduct, type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

import { useBookingItemAvailabilityStatus } from '../../../../../flecto-modules-saas/src'

type QueryPayload = {
  bookingId?: ParameterID
}

export function useQueryGetAllBookingProductsUnavailable({
  bookingId,
}: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetAllBookingProductsUnavailable', Number(bookingId)],
    refetchOnWindowFocus: false,
    enabled: isValidParameterID(bookingId),
    initialData: [],
    queryFn: async () => {
      const [booking, bookingProducts, bookingProductsAvailability] =
        await Promise.all([
          getBookingById(bookingId ?? ''),
          getAllBookingProducts(bookingId ?? ''),
          getAllBookingProductsAvailability(bookingId ?? ''),
        ])

      let unavailableProducts: CoreBookingProduct[] = []

      if (booking && bookingProducts && bookingProductsAvailability) {
        unavailableProducts = bookingProducts.filter((bi) => {
          const itemAvailability =
            bookingProductsAvailability?.product_availability.find((bia) => {
              return bia?.product?.id === bi?.product?.id
            })

          if (itemAvailability) {
            const item = bi.product

            const quantity = bi.quantity ?? 0

            const itemAvailabilityRemainingQty =
              itemAvailability.remaining_quantity ?? 0

            const remainingQuantity = ['drafting', 'negotiating'].includes(
              booking.status
            )
              ? itemAvailabilityRemainingQty - quantity
              : itemAvailabilityRemainingQty

            const { isUnavailable } = useBookingItemAvailabilityStatus({
              item,
              remainingQuantity,
            })

            return isUnavailable
          }

          return false
        })
      }

      return unavailableProducts
    },
  })
}
